import a from "./td-longtail-vue-components181.js";
/* empty css                              */
import s from "./td-longtail-vue-components98.js";
var l = function() {
  var e = this, r = e._self._c, t = e._self._setupProxy;
  return r(t.LinkButton, { staticClass: "energy-label-icon", attrs: { "aria-label": `Energieeffizienz ${e.energyClass}`, tag: e.tag, type: e.type, "no-styling": "" }, on: { click: function(n) {
    return n.stopPropagation(), n.preventDefault(), t.emitClick.apply(null, arguments);
  } } }, [r(t.Icon, { attrs: { "aria-hidden": "true", "energy-class": e.energyClass, reverse: e.reverse } }), e._t("lightbox", null, { title: t.title })], 2);
}, i = [], o = /* @__PURE__ */ s(
  a,
  l,
  i,
  !1,
  null,
  "4794fe99"
);
const u = o.exports;
export {
  u as default
};
